/* eslint-disable @typescript-eslint/naming-convention */
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {BlockElement, BlockElementSettings} from './blockElement';
import {BlockElementContainer, BlockElementLabel} from './blockElementContainer';
import {Entity} from '../../core/main.entity';
import {BlockElementGroupViewStyleList, BlockElementGroupViewTypeList, BlockElementType} from '../enums';
import {BlockElementGallery} from './blockElementGallery';
import {BlockElementWorker} from './blockElementWorker';
import {BlockElementArticle} from './blockElementAritlce';
import {BlockElementButton} from './blockElementButton';
import {BlockElementIcon} from './blockElementIcon';
import {BlockElementImage} from './blockElementImage';
import {Blocks} from './block.entity';

export class BlockElementGroup extends BlockElement {
  type: BlockElementType = 'group';

  @Type(() => BlockElementGroupItem)
  items?: BlockElementGroupItem[] = [];

  @Type(() => BlockElementGroupSettings)
  settings?: BlockElementGroupSettings = new BlockElementGroupSettings();
}

export class BlockElementGroupItem extends Entity {
  title: string = null;
  active? = false;

  @Type(() => BlockElementLabel)
  label?: BlockElementLabel = null;

  // @Type(() => Entity, {
  //   discriminator: {
  //     property: 'type',
  //     subTypes: [
  //       {value: BlockElementContainer, name: 'basic'},
  //       {value: BlockElementContainer, name: 'empty'},
  //       {value: BlockElementContainer, name: 'card'}
  //     ],
  //   },
  //   keepDiscriminatorProperty: true
  // })
  @Type(() => BlockElementContainer)
  items?: BlockElementContainer[] = [];

}

export class BlockElementGroupSettings extends BlockElementSettings {
  viewType?: BlockElementGroupViewTypeList = 'segments';
  viewStyle?: BlockElementGroupViewStyleList = 'secondary'; // add
}
